export default __webpack_public_path__ + "static/media/bank-linepay-square.57cb623c.svg";